import { facetParser, facetsParser, facetsParserToBackend } from './parser-facets'

import { swymFetch } from '~/services/fetch-swym'

import type { FacetResponse, FacetUnion } from '~/features-shared/facet/interfaces/facet'
import type { SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'

import type { SwymResponse } from '~/interfaces/services-dto'

/**
 * Get the facet list from backend and parse to be usable for the front end
 * Note: this call does not provide the parameter widgetPreference
 * @param communityUri
 * @param forceCheck Note this will be set as true when we are in the community_settings context (it tells to the backend to check if the media used for media_spotlight facets are still existing  ), this will never be equal to true in other use case for PCS issues
 * @returns Promise<Facet[]>
 */
export async function getFacets(communityUri: SUBJECT_6W_URI, forceCheck = false): Promise<FacetUnion[]> {
  return swymFetch
    .get(`/api/v2/communities/${communityUri}/facets?force_check=${forceCheck}`)
    .json<SwymResponse<FacetResponse[]>>()
    .then(response => facetsParser(response.result))
}

/**
 * Get information for a specific facet, this is manly used for retrieving the widgetPreference from a facet as they are not retrieve in /facets
 * @param communityUri
 * @param facetId
 * @returns Promise<Facet>
 */
export async function getFacet(communityUri: SUBJECT_6W_URI, facetId: string): Promise<FacetUnion> {
  return swymFetch
    .get(`/api/v2/communities/${communityUri}/facets/${facetId}`)
    .json<SwymResponse<FacetResponse>>()
    .then(response => facetParser(response.result))
}

/**
 * Save community facets
 * @param communityUri
 * @param facets
 * @returns Promise<Facet[]>
 */
export async function saveFacets(communityUri: SUBJECT_6W_URI, facets: FacetUnion[]): Promise<FacetUnion[]> {
  return swymFetch
    .post(`/api/v2/communities/${communityUri}/facets`, { json: facetsParserToBackend(facets) })
    .json<SwymResponse<FacetResponse[]>>()
    .then(response => facetsParser(response.result))
}
